import { render, staticRenderFns } from "./PermissionSetting.vue?vue&type=template&id=3485f4d0&"
import script from "./PermissionSetting.vue?vue&type=script&lang=js&"
export * from "./PermissionSetting.vue?vue&type=script&lang=js&"
import style0 from "./PermissionSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports